import moment from 'moment';

export function payPeriodsToSelectOptions(periods) {
  return periods.map((period) => {
    return {
      value: period.id,
      label:
        moment(period.startDate).format('ll') +
        ' to ' +
        moment(period.endDate).format('ll'),
    };
  });
}

export function usersToSelectOptions(users) {
  return users.map((user) => {
    return {
      value: user.id,
      label: user.lastName + ', ' + user.firstName,
    };
  });
}



// WEBPACK FOOTER //
// ./src/utils/selectDataFormatters.js